import cloneDeep from 'lodash.clonedeep';
import { NodeType } from '@amplify/amp-module';

/**
 * parseTokens
 * Method that parses {{token}} to values from the storage on runtime.
 * @param {*} value
 * @param {*} options
 * @returns
 */
export const parseTokens = (value, options = {}) => {
  if (!value) {
    return '';
  }

  const { isPreview, isPreviewRunning, storage } = options;

  // When in preview and it isn't running, then we don't want to replace any storage values
  if (isPreview && !isPreviewRunning) {
    return value;
  }

  // Let's locate all storage value elements added via the quill-mention plugin
  const domValue = document.createElement('div');
  domValue.innerHTML = value;
  const mentions = domValue.getElementsByClassName('mention');

  // We will then replace all the quill-mention elements with their associated value
  Array.from(mentions).forEach((mention) => {
    const { dataset: { value: mentionValue } } = mention;
    // removing the trailing }} chars as we manually add those
    const storeValue = mentionValue?.replace(/}}$/, '');
    const storeToken = storeValue && storage[storeValue];

    // If a storage value is found we will replace the token with the value,
    // otherwise we will delete the token from the ouput (unless we're in preview).
    if (storeToken !== undefined && storeToken !== null) {
      const textNode = document.createTextNode(storeToken);
      mention.parentNode.replaceChild(textNode, mention);
    } else if (!isPreview) {
      mention.parentNode.removeChild(mention);
    }
  });

  return domValue.innerHTML
    .toString()
    // Replacing any existing token strings e.g. {{test}}
    .replace(
      /\{\{([^"}]+)\}\}/gm,
      (fullMatch, token) => storage[token.trim()] ?? (isPreview ? fullMatch : ''),
    );
};

export const prepNodeForStack = (nodeData, parseOptions) => {
  const node = cloneDeep(nodeData);

  switch (node.type) {
    case NodeType.message:
      node.html = parseTokens(node.html, parseOptions);
      break;

    case NodeType.buttonGroup:
      Object.keys(node.subNodes).forEach((subId) => {
        node.subNodes[subId].buttonTexts = node.subNodes[subId].buttonTexts.map((text) => parseTokens(text, parseOptions));
      });
      break;

    case NodeType.question:
      node.html = parseTokens(node.html, parseOptions);
      Object.keys(node.subNodes).forEach((subId) => {
        node.subNodes[subId].buttonTexts = node.subNodes[subId].buttonTexts.map((text) => parseTokens(text, parseOptions));
      });
      break;

    case NodeType.carousel:
      Object.keys(node.subNodes).forEach((subId) => {
        node.subNodes[subId].headline = parseTokens(node.subNodes[subId].headline, parseOptions);
        node.subNodes[subId].description = parseTokens(node.subNodes[subId].description, parseOptions);
      });
      break;

    case NodeType.player:
      node.headline = parseTokens(node.headline, parseOptions);
      node.description = parseTokens(node.description, parseOptions);
      break;

    default:
      break;
  }

  return node;
};